var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestForChanges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44231 15.0006C2.03315 15.0006 1.68289 14.854 1.39152 14.561C1.10015 14.2679 0.954468 13.9155 0.954468 13.504V1.53126C0.954468 1.1197 1.10015 0.767374 1.39152 0.474292C1.68289 0.181209 2.03315 0.034668 2.44231 0.034668H8.39366L12.8572 4.52444V6.76933C12.572 6.83169 12.3054 6.93146 12.0575 7.06865C11.8095 7.20583 11.5801 7.38044 11.3693 7.59245L6.90582 12.0635V15.0006H2.44231ZM8.39366 15.0006V12.6996L12.5038 8.58394C12.6154 8.4717 12.7394 8.39063 12.8758 8.34075C13.0122 8.29086 13.1485 8.26592 13.2849 8.26592C13.4337 8.26592 13.5763 8.29398 13.7127 8.3501C13.8491 8.40622 13.9731 8.49041 14.0846 8.60265L14.7728 9.29482C14.872 9.40707 14.9495 9.53179 15.0052 9.66897C15.061 9.80616 15.0889 9.94335 15.0889 10.0805C15.0889 10.2177 15.0641 10.358 15.0145 10.5015C14.965 10.6449 14.8844 10.7727 14.7728 10.885L10.6812 15.0006H8.39366ZM13.2849 10.8101L13.9731 10.0805L13.2849 9.38836L12.5782 10.0992L13.2849 10.8101ZM7.64974 5.27274H11.3693L7.64974 1.53126V5.27274Z",
    fill: "#F3F3F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestForChanges);
export default __webpack_public_path__ + "static/media/requestForChanges.e97e7a9e23e81e1cea06cfe285e7c1f3.svg";
export { ForwardRef as ReactComponent };